<template>
  <div id="Home">
    <Sidebar />
    <div class="main-warp">
      <Navbar />
      <router-view class="page-warp" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar'
import Navbar from '@/components/Navbar'
export default {
  name: 'home',
  components: {
    Sidebar,
    Navbar
  }
}
</script>
<style lang="less" scope>
#Home {
  display: flex;
  height:100%;

  .main-warp {
    flex: 1;
    flex-direction: column;
    overflow: auto;
    display: flex;
    /*padding-bottom: 100px;*/
    .page-warp {
      overflow: auto;
      padding: 10px;
      flex: 1;
    }
  }
}
</style>
